export default __webpack_public_path__ + "static/media/waiting-for-email.e48c0a58.svg";